
import { Component, Prop, Vue } from "vue-property-decorator";
import { LeaderBoardTeams, PenaltyData } from "../../models/LeaderBoardTeams";
import { isEmpty, map, sortBy } from "lodash";
import { DateTime, Duration } from "luxon";
import StringHelper from "@/utils/StringHelper";
import DeleteTeam from "./DeleteTeam.vue";
import { UserData } from "@/models/User";

@Component({
  components: {
    DeleteTeam,
  },
})
class TeamListTable extends Vue {
  @Prop({ default: null }) readonly content!: LeaderBoardTeams;
  @Prop({ default: false }) readonly show!: boolean;
  @Prop({ default: false }) readonly showDeleteButton!: boolean;
  @Prop({ default: false }) readonly gameUid!: string;

  showSuccess = false;
  showError = false;

  get teamPoiSortedArr(): { title: string; localTime: string }[] {
    const ts = this.content as LeaderBoardTeams;
    if (!ts.map_poi || !ts || isEmpty(ts)) return [];

    const mapped = map(ts.map_poi, (poi) => {
      // * truncate any values above 17 to ellipsis
      const title = poi.title.en.substring(0, 40) + "...";

      return {
        title: title,
        localTime: DateTime.fromISO(poi.state.found_dt).toFormat("D TTT"),
      };
    });

    return sortBy(mapped, "localTime");
  }

  get generateLink(): string {
    return (
      process.env.VUE_APP_DATABASEURL +
      "/leaderboards/" +
      this.gameUid +
      "/team_stats/" +
      this.getSlugifyName(this.content.team_dname)
    );
  }

  get getUserData(): UserData {
    return this.$store.state.authenication.userData;
  }

  get localPenaltiesSortedArr(): PenaltyData[] {
    const ts = this.content as LeaderBoardTeams;
    if (!ts.timer?.applied || !ts || isEmpty(ts)) return [];

    const mapped = map(ts.timer?.applied, (adjustment) => {
      return {
        reason: adjustment.reason,
        evtDt: DateTime.fromISO(adjustment.utc).toFormat("D TTT"),
        valueMins: adjustment.value_m,
        valueStr: Duration.fromObject({ minutes: adjustment.value_m }).toFormat(
          "mm:ss"
        ),
      };
    });

    return sortBy(mapped, "evtDt");
  }

  get localTime(): string {
    return DateTime.fromISO(this.content.last_updated_utc).toFormat("D TTT");
  }

  get getDurationInSeconds(): string {
    return this.content.timer
      ? this.content.timer.comp_dur_s
        ? Duration.fromObject({
            seconds: this.content.timer.comp_dur_s,
          }).toFormat("hh:mm:ss")
        : "N/A"
      : "N/A";
  }

  get localBegan(): string {
    return this.content.timer?.began_dt
      ? DateTime.fromISO(this.content.timer?.began_dt).toFormat("D TTT")
      : "N/A";
  }

  get localFinished(): string {
    return this.content.timer?.fin_dt
      ? DateTime.fromISO(this.content.timer?.fin_dt).toFormat("D TTT")
      : "N/A";
  }

  get playDuration(): string {
    return Duration.fromObject({
      seconds: this.content.timer?.play_dur_s,
    }).toFormat("hh:mm:ss");
  }

  get offsetDuration(): string {
    return Duration.fromObject({
      minutes: this.content.timer?.offset_m,
    }).toFormat("hh:mm:ss");
  }

  deleteDialog(): void {
    this.$bvModal.show("team-modal-delete-team");
  }

  getEmail(): void {
    if (this.$store.state.authenication.isAdmin) {
      this.$store.dispatch("authenication/getEmailAddress").then((results) => {
        //console.log(results.val());
      });
    }
  }

  getSlugifyName(name: string): string {
    return StringHelper.Slugify(name);
  }

  deleteItem(): void {
    var data = {
      tgs: this.content.tgs,
      gameKey: this.gameUid,
      teamID: this.content.teamId,
    };
    this.$store
      .dispatch("toolBoxStore/resetPoi", data)
      .then((result) => {
        if (result.data) {
          this.showSuccess = true;
          this.showError = false;
        } else {
          this.showSuccess = false;
          this.showError = true;
        }
      })
      .catch((error) => {
        this.showError = true;
        this.showSuccess = false;
      });
  }

  handleClose(): void {
    this.$emit("closeTeamLeaderList");
  }
}
export default TeamListTable;
